<div class="main-container" [class.active]="isVisible">
  <div class="d-flex justify-content-between">
    <span class="details-text">Panja Information</span>
  </div>
  <div class="details-content" [class.active]="isVisible">
    @for(item of panjaData; track item){
    <div class="each-detail">
      <div class="details d-flex flex-column">
        <span class="details-heading">Panja Type</span>
        <div class="count-dtls d-flex justify-content-between">
          <span class="count">{{item.workerType}}</span>
        </div>
      </div>

    </div>
    <div class="each-detail">
      <div class="details d-flex flex-column">
        <span class="details-heading">Panja issue date</span>
        <div class="count-dtls d-flex justify-content-between">
          <span class="count">{{item.panjaDate || '-'}}</span>
        </div>

      </div>
    </div>
    <div class="each-detail">
      <div class="details d-flex flex-column">
        <span class="details-heading">Last renewal date</span>
        <div class="count-dtls d-flex justify-content-between">
          <span class="count">{{item.lastPanjaRenew || '-'}}</span>
        </div>
      </div>
    </div>
    <div class="each-detail">
      <div class="details d-flex flex-column">
        <span class="details-heading">Next Panja renewal due on</span>
        <div class="count-dtls d-flex justify-content-between">
          <span class="count">{{(formattedDate || '-') | date: 'MMMM yyyy'}}</span>
        </div>
      </div>

    </div>
    }
  </div>
  @if(isMobile && isVisible){
  <div class="warning-div">
    <div class="title">
      <span class="sheet-title">
        ⚠️ Your renewal is due
      </span>
    </div>
    <div class="btn-div">
      <button class="status-btn dp-primary-btn" (click)="check()">Check Status</button>
    </div>
  </div>
  }
</div>
@if(isVisible){
<div class="status-container right-side-slide">
  <div class="d-flex justify-content-between">
    <span class="details-text">Status</span>
  </div>
  @if (showSlot) {
   <div class="d-flex justify-content-between">
    <span class="common-text">Panja Receiving Slot - {{slot}}</span>
  </div>
}
  <div class="checkbox-details">
    @for(item of filteredData; track item){
    <div class="custom-checkbox">
      <input type="checkbox" name="checkbox" id="checkbox" [formControl]="renewDue">
      <span [ngClass]="item.isfailed ? 'fail-checkmark' : 'checkmark'"></span>
      <div class="d-flex flex-column">
        <span class="count">{{item.statusDesc}}</span>
        @if(item.isfailed){
        @if(item.renewalProcess.length > 1){
        <small
          style="color: var(--text-tertiary); display: flex; flex-wrap: wrap;">{{item.latestRemark.remarks}}</small>
        }@else{
        @for(remark of item.renewalProcess; track remark){
        <small style="color: var(--text-tertiary); display: flex; flex-wrap: wrap;">{{remark.remarks}}</small>

        }
        }
        }
      </div>
    </div>
    }

  </div>
</div>
}